window.increaseValue = function (number) {
    var value = parseInt(document.getElementById(number).value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    document.getElementById(number).value = value;
};

window.decreaseValue = function (number) {
    var value = parseInt(document.getElementById(number).value, 10);
    value = isNaN(value) ? 0 : value;
    value--;
    if (value < 1) {
        value = 1;
    }
    document.getElementById(number).value = value;
};

window.removeAddToCardModal = function () {
    var backdrop = document.getElementById('c-addtocardmodal_backdrop');
    var modal = document.getElementById('c-addtocardmodal');
    backdrop.remove();
    modal.remove();
};

window.submitform = function () {
    document.getElementById('DoRedirect').value = 'False';
    document.getElementById('shippingPayment').submit();
};

window.setDoRedirect = function () {
    document.getElementById('DoRedirect').value = 'True';
};
